export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const ERROR = `ERROR`;
export const SUCCESS = `SUCCESS`;